module.exports = "<div ng-if=\"submission.draftData.productCode === 'Homeowners'\">\n    <div gw-ho-confirmation/>\n</div>\n<div ng-if=\"submission.draftData.productCode === 'PersonalAuto'\">\n    <div gw-pa-confirmation/>\n</div>\n<div ng-if=\"submission.draftData.productCode === 'CommercialProperty'\">\n    <div gw-cp-confirmation/>\n</div>\n\n"


/*****************
 ** WEBPACK FOOTER
 ** ./common/grunt/webpack/loaders/text-loader!./common/js/src/integration/quoteandbind/directives/templates/confirmation.html
 ** module id = 428
 ** module chunks = 0
 **/